<template>
  <article id="events" class="layout-section">
    <section class="layout-section__hgroup -flex -events">
      <h2 v-appear:right="{ delay: 75 }" class="layout-section__title -no-bottom">
        {{ $t('common.navigation.events') }}
      </h2>

      <LocaleLink v-appear:left="{ delay: 125 }" :to="{ name: 'events' }" class="button">
        {{ $t('common.navigation.allEvents') }}
      </LocaleLink>
    </section>

    <section class="layout-section__flex -top -alt">
      <div ref="links" class="layout-section__split -small layout-links">
        <div class="layout-links__content">
          <h5
            v-for="(name, slug, index) in slugs"
            :key="slug"
            v-appear:right="{ delay: index * 25 }"
            class="layout-links__item"
            :class="{ '-active': slug === currentConferenceSlug }"
            @click="currentConferenceSlug = slug"
          >
            {{ name }}
          </h5>
        </div>
      </div>

      <transition name="fade-out" mode="out-in">
        <div :key="currentConferenceSlug" class="layout-section__split -large">
          <span v-appear class="layout-section__toptitle">{{ currentConference.name }}</span>
          <h5 v-appear="{ delay: 50 }" class="layout-section__subtitle">
            {{ nextEvent.title || currentConference.shortName }}
          </h5>

          <div v-if="nextEvent.homeContent" v-appear="{ delay: 125 }" v-html="nextEvent.homeContent" />

          <div v-else>
            <p>{{ currentConference.about }}</p>
          </div>

          <div class="layout-section__cta">
            <LocaleLink
              v-appear="{ delay: 300 }"
              :to="{ name: 'conference', params: { slug: currentConferenceSlug } }"
              class="button -secondary"
            >
              {{ $t(`common.cta.learnMore`) }}
            </LocaleLink>

            <a
              v-if="nextEvent.registerLink"
              v-appear="{ delay: 325 }"
              :href="nextEvent.registerLink"
              target="_blank"
              class="button"
            >
              {{ $t(`common.cta.tickets`) }}
            </a>
          </div>
        </div>
      </transition>
    </section>

    <transition name="fade-out" mode="out-in">
      <HomeEventsGallery v-if="hasGallery" :key="currentConferenceSlug" :images="gallery" />
    </transition>

    <LocaleLink v-appear:left="{ delay: 125 }" :to="{ name: 'events' }" class="button -mobile">
      {{ $t('common.navigation.allEvents') }}
    </LocaleLink>
  </article>
</template>

<script>
import moment from 'moment'
import SimpleBar from 'simplebar'
import HomeEventsGallery from './HomeEventsGallery.vue'

export default {
  name: 'HomeEvents',
  components: { HomeEventsGallery },
  data() {
    return {
      simplebarInstance: null,
      currentConferenceSlug: null
    }
  },
  computed: {
    conferences() {
      return this.$i18n.messages[this.$i18n.locale].home.conferences.reduce((conferences, conferenceId) => {
        const [slug, conference] = Object.entries(this.$i18n.messages[this.$i18n.locale].conferences).find(
          keyPair => keyPair[1].id === conferenceId
        )

        return conference ? { ...conferences, [slug]: conference } : conferences
      }, {})
    },
    slugs() {
      return Object.entries(this.conferences).reduce((slugs, [slug, { shortName }]) => {
        return Object.assign(slugs, { [slug]: shortName })
      }, {})
    },
    currentConference() {
      return this.conferences[this.currentConferenceSlug]
    },
    hasGallery() {
      return this.currentConference.hasGallery === 'true' && Array.isArray(this.currentConference.gallery)
    },
    gallery() {
      return this.currentConference.galleryPreview || []
    },
    nextEvent() {
      return Array.isArray(this.currentConference.events)
        ? this.currentConference.events.find(({ startDate }) => moment(startDate).isAfter(moment())) || {}
        : {}
    },
    hasTicketsButton() {
      return /^http/.test(this.$t(`events.home.${this.currentCity}.buyTickets`))
    }
  },
  beforeMount() {
    const [slug] = Object.keys(this.slugs)
    this.currentConferenceSlug = slug
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.$refs.links || this.$device.tabletH) return
      this.simplebarInstance = new SimpleBar(this.$refs.links)
    })
  },
  methods: {
    getInternalLink(href) {
      return { name: href.replace('page:', '') }
    }
  }
}
</script>
